import { useCallback } from 'react';
import { DateObject, DateObjectInputDate } from '../dateObject';

type Seconds = number;
type Dates = [date1: DateObjectInputDate, date2: DateObjectInputDate];

export interface DurationFormatOptions {
  unitDisplay?: 'long' | 'short' | 'narrow';
}

export function useDurationFormat() {
  return useCallback((input: Seconds | Dates, options?: DurationFormatOptions) => {
    const totalSeconds = Array.isArray(input) ? new DateObject(input[0]).differenceInSeconds(input[1]) : input;
    const unitDisplay = options?.unitDisplay ?? 'narrow';
    const minimumFractionDigits = 0;
    const maximumFractionDigits = 0;

    const hoursFormatter = new Intl.NumberFormat(undefined, {
      style: 'unit',
      unit: 'hour',
      unitDisplay,
      minimumFractionDigits,
      maximumFractionDigits
    });

    const minutesFormatter = new Intl.NumberFormat(undefined, {
      style: 'unit',
      unit: 'minute',
      unitDisplay: 'narrow',
      minimumFractionDigits,
      maximumFractionDigits
    });

    const secondsFormatter = new Intl.NumberFormat(undefined, {
      style: 'unit',
      unit: 'second',
      unitDisplay: 'narrow',
      minimumFractionDigits,
      maximumFractionDigits
    });

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hoursFormatter.format(hours)} ${minutesFormatter.format(minutes)} ${secondsFormatter.format(seconds)}`;
  }, []);
}
